import type { PlayerStat } from 'types'

export const findStat = (statName: PlayerStat['name'], stats: PlayerStat[]) => {
  const matchingStat = stats.find((stat) => stat.name.trim() === statName)

  return matchingStat?.value
}
